import { call, put, takeLatest } from 'redux-saga/effects';

import { CancerQuoteApi } from '@apis/CancerQuoteApi';
import { CancerQuote } from '@models/CancerQuote';
import { SagaPayload } from '@utils/typescript';

import {
  cancerQuoteFind,
  CancerQuoteFindPayload,
  cancerQuoteSendEmail,
  CancerQuoteSendEmailPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleCancerQuoteFetch({ payload }: SagaPayload<CancerQuoteFindPayload>) {
  const state: StateUpdatePayload = { cancerQuote: null };
  try {
    state.cancerQuote = (yield call(CancerQuoteApi.find, payload)) as CancerQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCancerQuoteSendEmail({ payload }: SagaPayload<CancerQuoteSendEmailPayload>) {
  yield call(CancerQuoteApi.sendEmail, payload);
}

export default function* () {
  yield takeLatest(cancerQuoteFind, handleCancerQuoteFetch);
  yield takeLatest(cancerQuoteSendEmail, handleCancerQuoteSendEmail);
}
